import React, {useContext, useEffect} from "react";
import { useLocation } from "react-router-dom";
import UserContext from "../../../../contexts/userContext";
import { Drawer } from "antd";
import { RiCloseFill } from "react-icons/ri";
import MenuLogo from "../logo";
import PoMenuItem from '../po';
import TravelMenuItem from '../travel';
import TravelManager from '../travel_manager';
import PoManager from '../po_manager';
import MenuFooter from "../footer";

export default function MenuMobile(props) {
    const { onClose, visible } = props;
    const { userprofile } = useContext(UserContext);

    // based navigation
    const location = useLocation();
    const subPage = location.pathname.split('/')[1]; // Extract the sub-page from the URL

    return (
        <Drawer
            title={
                <MenuLogo onClose={onClose} />
            }
            width={256}
            className="hp-mobile-sidebar"
            placement="left"
            closable={true}
            onClose={onClose}
            visible={visible}
            closeIcon={
                <RiCloseFill
                    className="remix-icon hp-text-color-black-80"
                    size={24}
                />
            }
        >
            
            {userprofile.is_normal_user ? (
                subPage === "po-dashboard" ? (
                    <PoMenuItem onClose={onClose} />
                ) : subPage === "travel-dashboard" ? (
                    <TravelMenuItem onClose={onClose} />
                ) : subPage === "notification-list" || subPage === "pages" ? (
                    <PoMenuItem onClose={onClose} /> // or <TravelMenuItem onClose={onClose} /> based on your requirement
                ) : null
            ) : (
                !userprofile.is_normal_user && (
                    subPage === "po-dashboard" ? (
                    <PoManager onClose={onClose} />
                    ) : subPage === "travel-dashboard" ? (
                    <TravelManager onClose={onClose} />
                    ) : subPage === "notification-list" || subPage === "system-variables"  || subPage === "pages" ? (
                    <PoManager onClose={onClose} />
                    ) : null
                )
            )}


            <MenuFooter onClose={onClose} collapsed={false} />
        </Drawer>
    );
};